import { render, staticRenderFns } from "./CargoPermissionsDropdown.vue?vue&type=template&id=2afdbcd2"
import script from "./CargoPermissionsDropdown.vue?vue&type=script&lang=js"
export * from "./CargoPermissionsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports